import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { corporateCMSApi, post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { useManagementTeamDetails } from "../Organization.hook";
import { fields, fieldsReady } from "../constants";

export const AddEditManagementTeam = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();
  const [records, setRecords] = useState<any[]>([]);

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useManagementTeamDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");
  const [fieldData, setFieldData] = useState<any>();

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);
  const getRecords = () => {
    let url = `/api/get-organisation/all-fields/management-team`;
    corporateCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch((err) => {
        setRecords([]);
      });
  };
  useEffect(() => {
    getRecords();
  }, []);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      published: dataById
        ? decodeHTML(dataById.payload?.published)
        : editData
          ? decodeHTML(editData?.published)
          : false,
      title: dataById ? decodeHTML(dataById.payload.title) : editData ? decodeHTML(editData?.title) : "",
      field_title_name_ms: dataById
        ? decodeHTML(dataById.payload.field_title_name_ms)
        : editData
          ? decodeHTML(editData.field_title_name_ms)
          : "",
      field_title_name_zh: dataById
        ? decodeHTML(dataById.payload.field_title_name_zh)
        : editData
          ? decodeHTML(editData?.field_title_name_zh)
          : "",
      field_designation_en: dataById
        ? decodeHTML(dataById.payload.field_designation_en)
        : editData
          ? decodeHTML(editData?.field_designation_en)
          : "",
      field_designation_ms: dataById
        ? decodeHTML(dataById.payload.field_designation_ms)
        : editData
          ? decodeHTML(editData.field_designation_ms)
          : "",
      field_designation_zh: dataById
        ? decodeHTML(dataById.payload.field_designation_zh)
        : editData
          ? decodeHTML(editData?.field_designation_zh)
          : "",
      field_organisation_order_sequenc: dataById
        ? decodeHTML(dataById.payload.field_organisation_order_sequenc)
        : editData
          ? decodeHTML(editData?.field_organisation_order_sequenc)
          : "",
      field_description_en: dataById
        ? decodeHTML(dataById.payload.field_description_en)
        : editData
          ? decodeHTML(editData?.field_description_en)
          : "",
      field_description_ms: dataById
        ? decodeHTML(dataById.payload.field_description_ms)
        : editData
          ? decodeHTML(editData?.field_description_ms)
          : "",
      field_description_zh: dataById
        ? decodeHTML(dataById.payload.field_description_zh)
        : editData
          ? decodeHTML(editData?.field_description_zh)
          : "",
      field_link_en: dataById
        ? decodeHTML(dataById.payload.field_link_en)
        : editData
          ? decodeHTML(editData?.field_link_en)
          : "",
      field_link_ms: dataById
        ? decodeHTML(dataById.payload.field_link_ms)
        : editData
          ? decodeHTML(editData.field_link_ms)
          : "",
      field_link_zh: dataById
        ? decodeHTML(dataById.payload.field_link_zh)
        : editData
          ? decodeHTML(editData?.field_link_zh)
          : "",
      // field_page_en: dataById
      //     ? decodeHTML(dataById.payload.field_page_en)
      //     : editData
      //     ? decodeHTML(editData?.field_page_en)
      //     : "",
      // field_page_ms: dataById ? decodeHTML(dataById.payload.field_page_ms) : editData ? decodeHTML(editData.field_page_ms) : "",
      // field_page_zh: dataById
      //     ? decodeHTML(dataById.payload.field_page_zh)
      //     : editData
      //     ? decodeHTML(editData?.field_page_zh)
      //     : "",
      field_categories: dataById
        ? decodeHTML(dataById.payload.field_categories)
        : editData
          ? decodeHTML(editData?.field_categories)
          : "",
      field_categories_ms: dataById
        ? decodeHTML(dataById.payload.field_categories_ms)
        : editData
          ? decodeHTML(editData.field_categories_ms)
          : "",
      field_categories_zh: dataById
        ? decodeHTML(dataById.payload.field_categories_zh)
        : editData
          ? decodeHTML(editData?.field_categories_zh)
          : "",
      field_organisation_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_organisation_image.png",
              status: "done",
              url: dataById?.payload?.field_organisation_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_organisation_image.png",
              status: "done",
              url: editData?.field_organisation_image,
            },
          ]),
    },
    fields: fieldData?.managementTeamPageContent?.map((field: any) => {
      if (field.name === "field_organisation_order_sequenc") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find((record: any) => {
                return (
                  toInteger(record[field.name]) === toInteger(value) &&
                  record.id !== (editData?.id || dataById?.payload?.id)
                );
              });
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image", "field_organisation_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }
    let numberKeys: any = ["field_organisation_order_sequenc"];

    for (const key of numberKeys) {
      try {
        let field = data[key];
        if (field !== undefined && field !== null && field !== "") {
          data[key] = Number(field);
        }
      } catch (error) {
        console.error(`Error converting ${key} to number:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Organization",
      subModule: "managementTeam_managementTeamPageContent",
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Organization_Management Team",
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...data,
        field_page_zh: editData?.field_page_zh || dataById?.payload?.field_page_zh,
        field_page_en: editData?.field_page_en || dataById?.payload?.field_page_en || "management-team",
        field_page_ms: editData?.field_page_ms || dataById?.payload?.field_page_ms,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Management Team`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === "update"
              ? `${corporateHost}/api/organisation-view/${dataById?.payload?.id || editData?.id}`
              : `${corporateHost}/api/create/organisation-view`,
            query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Organization"
      />
    </ContentWrapper>
  );
};
